import { axiosInstance } from "@/apis/core";

export interface ApiLogEntry {
  logId: number;
  method: string;
  url: string;
  statusCode: number | null;
  userId: string | null;
  userName: string | null;
  roleId: string | null;
  ipAddress: string | null;
  responseTime: number | null;
  crDt: string;
}

export interface ApiLogResponse {
  content: ApiLogEntry[];
  totalElements: number;
  totalPages: number;
}

export const fetchApiLogs = async (
  page: number,
  size: number,
  filters?: {
    userId?: string;
    method?: string;
    fromDate?: string;
    toDate?: string;
  },
): Promise<ApiLogResponse> => {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("size", String(size));
  if (filters?.userId) params.set("userId", filters.userId);
  if (filters?.method) params.set("method", filters.method);
  if (filters?.fromDate) params.set("fromDate", filters.fromDate);
  if (filters?.toDate) params.set("toDate", filters.toDate);

  const res = await axiosInstance.get(
    `portal-service/api/v1/log/list?${params.toString()}`,
  );
  return res.data;
};
